const Header = () => (
    <h1>
        PDB Archive over HTTP
    </h1>
);

export default Header;
